/* eslint-disable no-extend-native */
import { toTemporalInstant } from '@js-temporal/polyfill'

class CustomDate extends Date {
  constructor (...args: any[]) {
    if (args.length === 0) {
      // Chama o construtor de Date sem argumentos (data fixa)
      super()
    } else if (args.length === 1) {
      // Chama o construtor de Date com um argumento (string, número ou Date)
      // Verifica se o argumento é um data (xxxx-xx-xx), se true concatena o horário para não dar conflito
      super(/^\d{4}-\d{2}-\d{2}$/.test(args[0]) ? `${args[0]} 00:00:00` : args[0])
    } else {
      // Chama o construtor de Date com múltiplos argumentos (ano, mês, dia, etc.)
      super(
        args[0], // ano
        args[1], // mês
        args[2] ?? 1, // dia (padrão: 1)
        args[3] ?? 0, // horas
        args[4] ?? 0, // minutos
        args[5] ?? 0, // segundos
        args[6] ?? 0 // milissegundos
      )
    }
  }
}

// Sobrescrevendo o construtor globalmente
(globalThis as any).Date = CustomDate

declare global {
  export interface Date {
    formatDate(format?: Intl.DateTimeFormatOptions): string
    formatTime(): string
    formatTimeAgo(): string
    toTemporalInstant: typeof toTemporalInstant
  }
}

const weekInMilis = 1000 * 60 * 60 * 24 * 7
const dayInMilis = 1000 * 60 * 60 * 24
const hourInMilis = 1000 * 60 * 60
const minuteInMilis = 1000 * 60
const secondInMilis = 1000

interface DateFormats {
  ddMMYYYY?: Intl.DateTimeFormatOptions
  ddMM?: Intl.DateTimeFormatOptions
  ddMMYYYHHMM?: Intl.DateTimeFormatOptions
}

const dateFormats: DateFormats = {
  ddMMYYYY: {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  },
  ddMM: {
    day: '2-digit',
    month: '2-digit'
  },
  ddMMYYYHHMM: {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }
}

Date.prototype.formatDate = function formatDate (
  this: Date,
  format = dateFormats.ddMMYYYY,
  timeZone = 'America/Sao_Paulo'
): string {
  return this.toLocaleDateString('pt-BR', { ...format, timeZone }).replace(',', '')
}

Date.prototype.formatTime = function formatTime (this: Date, timeZone = 'America/Sao_Paulo'): string {
  return this.toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
    timeZone
  })
}

Date.prototype.formatTimeAgo = function formatTimeAgo (this: Date): string {
  const formatter = new Intl.RelativeTimeFormat('pt-BR', { style: 'long' })
  const diff = new Date().getTime() - this.getTime()

  if (diff / weekInMilis >= 1) {
    return this.formatDate(dateFormats.ddMM)
  } else if (diff / dayInMilis >= 1) {
    return formatter.format(Math.floor(-diff / dayInMilis), 'days')
  } else if (diff / hourInMilis >= 1) {
    return formatter.format(Math.floor(-diff / hourInMilis), 'hours')
  } else if (diff / minuteInMilis >= 1) {
    return formatter.format(Math.floor(-diff / minuteInMilis), 'minutes')
  } else {
    return formatter.format(Math.floor(-diff / secondInMilis), 'seconds')
  }
}

Date.prototype.toTemporalInstant = toTemporalInstant

export { dateFormats }
